import { api_GET, api_POST, api_PUT, api_DELETE, api_POST_Unauthorize } from "./_api.js";

const agenda_api = {
    GetList: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Agenda/GetList`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetLocalidadesGerador: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Agenda/GetLocalidadesGerador`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default agenda_api;
